import {
  DateInput,
  FormInput,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid, Stack, Typography } from "@mui/material";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TicketFlowPatternMessagesMarcom } from "./TicketFlowPatternMessagesMarcom";
import { TicketChannelMessagesMarcom } from "./TicketChannelMessagesMarcom";
import { TicketChannelStepMessagesMarcom } from "./TicketChannelStepMessagesMarcom";
import { IsMoveHumanAttendant } from "./IsMoveHumanAttendant";
import { TMessageForm } from "../messagesSchema";
import { useWatch } from "react-hook-form";
import { TicketAutomationReceivedRuleMessagesMarcom } from "./TicketAutomationReceivedRuleMessagesMarcom";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

export const MessageFields = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TMessageForm>();

  const finishedFromStart = useWatch({
    control,
    name: "finishedFromStart",
  });

  const moveTicketWhenNotIdentified = useWatch({
    control,
    name: "moveTicketWhenNotIdentified",
  });

  const ticketAutomationReceivedRule = useWatch({
    control,
    name: "ticketAutomationReceivedRule",
  });

  useEffect(() => {
    if (!ticketAutomationReceivedRule) {
      setValue("moveTicketWhenNotIdentified", false);
    }
  }, [ticketAutomationReceivedRule, setValue]);

  useEffect(() => {
    if (!moveTicketWhenNotIdentified) {
      setValue("ticketChannelWhenNotIdentified", null);
      setValue("ticketChannelStepWhenNotIdentified", null);
    }
  }, [moveTicketWhenNotIdentified, setValue]);

  return (
    <Stack spacing={3}>
      <Grid
        container
        spacing={2}
        sx={(t) => ({
          pr: 3,
          pl: 1,
          py: 3,
          borderRadius: 2,
        })}
      >
        <Grid item sm={12} textAlign="end">
          <SwitchInput name="enable" label={t(translationPath + "enable")} />
        </Grid>

        <Grid item xs={12} sm={9}>
          <FormInput
            size="small"
            name="name"
            fullWidth
            label={t(translationPath + "name") || "Name"}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormInput
            size="small"
            name="priority"
            fullWidth
            label={t(translationPath + "priority") || "Priority"}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput
            name="startDate"
            label={t(translationPath + "start_date")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput name="endDate" label={t(translationPath + "end_date")} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Typography fontWeight="bold">
            {t(translationPath + "ticket_flow_pattern")}
          </Typography>
        </Grid>

        <TicketFlowPatternMessagesMarcom />

        {finishedFromStart && (
          <>
            <TicketChannelMessagesMarcom />

            <TicketChannelStepMessagesMarcom />

            <IsMoveHumanAttendant />

            <TicketAutomationReceivedRuleMessagesMarcom />

            {ticketAutomationReceivedRule && (
              <Grid item sm={12}>
                <SwitchInput
                  name="moveTicketWhenNotIdentified"
                  label={t(translationPath + "move_ticket_when_not_identified")}
                />
              </Grid>
            )}

            {ticketAutomationReceivedRule && moveTicketWhenNotIdentified && (
              <>
                <TicketChannelMessagesMarcom
                  name="ticketChannelWhenNotIdentified"
                  stepFieldName="ticketChannelStepWhenNotIdentified"
                />

                <TicketChannelStepMessagesMarcom
                  name="ticketChannelStepWhenNotIdentified"
                  ticketChannelFieldName="ticketChannelWhenNotIdentified"
                />
              </>
            )}
          </>
        )}
      </Grid>
    </Stack>
  );
});
